import { request } from '.';
import { openNotification } from '../common';

export async function logout() {
  return request.get(`/Auth/Api/v1/Authentication/LogOut`).then((response) => {
    openNotification('success', response.message);
    return response.data;
  });
}
